// extracted by mini-css-extract-plugin
export default {"articleFreeCard":"article_free_articleFreeCard__g+17M","noBlocksMessage":"article_free_noBlocksMessage__wDndN"};